import { withClassName } from 'lp-hoc'

const SectionBlock = withClassName('section-block card')('section')

export default SectionBlock
